import {
  COTIZADOR_ACT_GET_MODELS_BEGIN,
  COTIZADOR_ACT_GET_MODELS_SUCCESS,
  COTIZADOR_ACT_GET_MODELS_FAILURE,
  COTIZADOR_ACT_GET_MODELS_DISMISS_ERROR,
} from './constants'
import { getModels } from 'BFF/BFF_cotizador/getModels'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actGetModels(args = {}) {
  return async (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COTIZADOR_ACT_GET_MODELS_BEGIN,
    })

    try {
      const result = await getModels(args.id);
      dispatch({
        type: COTIZADOR_ACT_GET_MODELS_SUCCESS,
        data: result.data
      })
    } catch (err) {
      dispatch({
        type: COTIZADOR_ACT_GET_MODELS_FAILURE,
        data: { error: err },
      })
    }
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActGetModelsError() {
  return {
    type: COTIZADOR_ACT_GET_MODELS_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_ACT_GET_MODELS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actGetModelsPending: true,
        actGetModelsError: null,
      }

    case COTIZADOR_ACT_GET_MODELS_SUCCESS:
      // The request is success
      return {
        ...state,
        actGetModelsPending: false,
        actGetModelsError: null,
        models: action.data.data,
      }

    case COTIZADOR_ACT_GET_MODELS_FAILURE:
      // The request is failed
      return {
        ...state,
        actGetModelsPending: false,
        actGetModelsError: action.data.error,
      }

    case COTIZADOR_ACT_GET_MODELS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actGetModelsError: null,
      }

    default:
      return state
  }
}
